<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 login-max-w sm:m-0 m-4">
      <vs-alert class="mb-5" title="Nueva imagen " active="true">
        Queremos compartir una gran noticia contigo: DigitaFirma ahora es Verificamex. Puedes seguir accediendo con tus mismos datos.
      </vs-alert>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color bg-wite">

          <div class="vx-row no-gutter justify-center">

            <div class="vx-col hidden lg:block lg:w-1/2 px-4 py-5 color-bg-login min-h-login">
              <div >
                <img class="mb-5 max-w-logo d-block m-auto" src="@/assets/images/logo/logo-full.svg" alt="registerImg">
                <img src="@/assets/images/pages/login.svg" alt="login" class="mx-auto">
              </div>
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container py-login">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Inicio</h4>
                  <p>Bienvenido de nuevo, inicia sesión en tu cuenta.</p>
                </div>

                <vs-row>
                  <div class="vx-col w-full md:w-full lg:w-1/2 lg:pr-2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                    <a
                      class="btn-google"
                      href="https://api.digitafirma.com/oauth2/authorize/google?redirect_uri=https://app.verificamex.com/signature/oauth2/redirect">
                      <div class="google-content">
                        <div class="logo">
                          <svg width="2443" height="2500" viewBox="0 0 256 262" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"><path d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027" fill="#4285F4"/><path d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1" fill="#34A853"/><path d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782" fill="#FBBC05"/><path d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251" fill="#EB4335"/></svg>
                        </div>
                        <p>Acceder con Google</p>
                      </div>
                    </a>
                  </div>
                  <div  class="vx-col w-full md:w-full lg:w-1/2 lg:pl-2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                    <a
                      class="btn-google"
                      href="https://api.digitafirma.com/oauth2/authorize/linkedin?redirect_uri=https://app.verificamex.com/signature/oauth2/redirect">
                      <div class="google-content">
                        <div class="logo">
                          <svg height="2500" width="2490" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><g fill="none"><path d="M0 18.338C0 8.216 8.474 0 18.92 0h218.16C247.53 0 256 8.216 256 18.338v219.327C256 247.79 247.53 256 237.08 256H18.92C8.475 256 0 247.791 0 237.668V18.335z" fill="#069"/><path d="M77.796 214.238V98.986H39.488v115.252H77.8zM58.65 83.253c13.356 0 21.671-8.85 21.671-19.91-.25-11.312-8.315-19.915-21.417-19.915-13.111 0-21.674 8.603-21.674 19.914 0 11.06 8.312 19.91 21.169 19.91h.248zM99 214.238h38.305v-64.355c0-3.44.25-6.889 1.262-9.346 2.768-6.885 9.071-14.012 19.656-14.012 13.858 0 19.405 10.568 19.405 26.063v61.65h38.304v-66.082c0-35.399-18.896-51.872-44.099-51.872-20.663 0-29.738 11.549-34.78 19.415h.255V98.99H99.002c.5 10.812-.003 115.252-.003 115.252z" fill="#fff"/></g></svg>
                        </div>
                        <p>Acceder con Linkedin</p>
                      </div>
                    </a>
                  </div>
                </vs-row>
                <form @submit="submitLogin">
                  <div>

                    <vs-input
                        label-placeholder="Correo"
                        name="email"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        v-model="email"
                        class="w-full"/>

                    <vs-input
                        label-placeholder="Contraseña"
                        :type="type"
                        name="password"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        v-model="password"
                        class="w-full mt-6" />
                    <div class="form-control-position field-icon">
                      <a @click="showPassword">
                        <feather-icon :icon="icon" class="top-4 " svgClasses="w-5 h-5 icon-color"></feather-icon>
                      </a>
                    </div>

                    <div class="flex flex-wrap justify-between my-5">
                        <router-link to="/forgot-password">¿Olvidaste tu contraseña?</router-link>
                    </div>
                    <input type="submit" style="position: absolute; left: -9999px"/>
                    <vs-button :disabled="status.loggingIn" ref="loadableButton" id="button-with-loading" class="vs-con-loading__container" @click="submitLogin" type="relief" vslor="primary">Iniciar</vs-button>
                    <vs-button  type="border" to="/register" class="float-right">Registrate gratis</vs-button>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import router from "../../../../router";

export default{
  data() {
    return {
      icon: 'EyeIcon',
      type: 'password',
      email: "",
      password: "",
      checkbox_remember_me: false
    }
  },
  created() {
    this.logout()
  },
  computed: {
    ...mapState('account', ['status']),
  },
  methods: {
    showPassword() {
      if(this.type === 'password') {
        this.type = 'text'
        this.icon = 'EyeOffIcon'
      } else {
        this.type = 'password'
        this.icon = 'EyeIcon'
      }
    },
    ...mapActions('account', ['login', 'logout']),
    submitLogin(e) {
      if (e) {
        e.preventDefault();
      }
      const {email, password} = this;
      this.$store.dispatch("alert/clear", {});
      if (email && password) {
        this.$vs.loading({
          background: 'primary',
          color: '#fff',
          container: "#button-with-loading",
          scale: 0.45
        });
        this.login({email, password, aclChangeRole: this.$acl.change})
        .then(
          () => {
            this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          },
          error => {
            this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          }
        )
      } else {
        this.$store.dispatch("alert/error", "Ingrese los datos requeridos");
      }
    }

  }
}
</script>

<style>
.vs-button-primary.vs-button-relief {
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
